/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2024-01-11T10:42:57.384
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentHouseHoldItemHistory,
	listRentHouseHoldItemHistoryInit,
	listRentHouseHoldItemHistoryByAuthorizations,
	deleteRentHouseHoldItemHistory
	
} from '@api/rentmanage/RentHouseHoldItemHistory';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentHouseHoldItemHistory({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseHoldItemHistory(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseHoldItemHistoryByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseHoldItemHistoryByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseHoldItemHistoryInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseHoldItemHistoryInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHouseHoldItemHistory({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseHoldItemHistory({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
